import { render, staticRenderFns } from "./PatientDoctorDataTable.vue?vue&type=template&id=3b7b8cae&scoped=true"
import script from "./PatientDoctorDataTable.vue?vue&type=script&lang=js"
export * from "./PatientDoctorDataTable.vue?vue&type=script&lang=js"
import style0 from "./PatientDoctorDataTable.vue?vue&type=style&index=0&id=3b7b8cae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b7b8cae",
  null
  
)

export default component.exports